import React from "react";
import { Col, Row } from "antd";
import logo from '../../assets/prism-logo.png';

interface DamagePdfProps {
  response?: any;
  inspectionId?: string;
  vinId?: string;
  podId?: string;
  systemDate?: string;
  terminalName?: string;
  make?: string;
  model?: string;
  year?: string | number;
}

const DamagePdf: React.FC<DamagePdfProps> = ({
  response = [], // ✅ default fallback
  inspectionId,
  vinId,
  podId,
  systemDate,
  terminalName,
  make,
  model,
  year,
}) => {
  // const [images, setImages] = React.useState<any>([])
  const todayDate = new Date().toISOString().split("T")[0];

  // ✅ Normalize response (handles [], null, {data: []})
  const damageList = Array.isArray(response)
    ? response
    : Array.isArray(response?.data)
    ? response.data
    : [];

  return (
    <>
      {/* ---------------- HEADER ---------------- */}
      <div
        className={`i${inspectionId}-pdf-header`}
        style={{
          margin: 0,
          padding: 0,
          fontFamily: "Arial, Helvetica, sans-serif",
          color: "#404040",
          lineHeight: "21px",
          background: "#f6f6f6",
        }}
      >
        <div
          style={{
            height: "auto",
            margin: "auto",
            position: "relative",
            background: "#f6f6f6",
          }}
        >
          <header
            style={{
              borderTop: "15px solid #e94f2c",
              padding: "4vh 8vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#FFFFFF",
            }}
          >
            <h1
              style={{
                color: "#e94f2c",
                fontWeight: "bold",
                fontSize: "2rem",
                margin: 0,
              }}
            >
              Damage Detection Report
            </h1>
            <img
              src={logo}
              width={200}
              height={50}
              alt="cust logo"
            />
          </header>

          <div
            style={{
              borderTop: "1px solid #dadada",
              padding: "4vh 8vw 5vh 8vw",
              background: "#FFFFFF",
            }}
          >
            {/* Title Row */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={{ fontSize: "2rem", margin: 0 }}>
                Vehicle and location details
              </h2>
              <div style={{ textAlign: "right" }}>
                <h2 style={{ fontSize: "1.5rem", margin: 0 }}>
                  VIN: { vinId || "-"}
                </h2>
                <p
                  style={{
                    margin: 3,
                    paddingTop: 5,
                    fontSize: "1rem",
                    color: "#777",
                  }}
                >
                  Report Date: {todayDate}
                </p>
              </div>
            </div>

            {/* Table */}
            <table
              style={{
                width: "100%",
                border: "1px solid #dadada",
                borderCollapse: "collapse",
                marginTop: "25px",
              }}
            >
              <tbody>
                <tr>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Location:</Col>
                      <Col style={valueStyle}>
                        {terminalName || "-"}
                      </Col>
                  </Row>
                  </td>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Inspection Type:</Col>
                      <Col style={valueStyle}>AI/Manual</Col>
                    </Row>
                  </td>
                </tr>

                <tr>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>POD:</Col>
                      <Col style={valueStyle}>{podId || "-"}</Col>
                    </Row>
                  </td>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Make:</Col>
                      <Col style={valueStyle}>{ make || "-"}</Col>
                    </Row>
                  </td>
                </tr>

                <tr>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Inspection Date:</Col>
                      <Col style={valueStyle}>
                        {systemDate?.split("T")?.[0] || "-"}
                      </Col>
                    </Row>
                  </td>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Model:</Col>
                      <Col style={valueStyle}>{ model || "-"}</Col>
                    </Row>
                  </td>
                </tr>

                <tr>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Inspection Entry Time:</Col>
                      <Col style={valueStyle}>
                        {systemDate?.split("T")?.[1]?.split(".")[0] || "-"}
                      </Col>
                    </Row>
                  </td>
                  <td style={cellStyle}>
                    <Row justify="space-between">
                      <Col>Year:</Col>
                      <Col style={valueStyle}>{ year || "-"}</Col>
                    </Row>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* ---------------- DAMAGE SUMMARY ---------------- */}
          <div
            style={{
              borderTop: "1px solid #dadada",
              padding: "0 8vw",
              height: "120vh",
            }}
            
          >
            <h2
              style={{
                fontSize: "2rem",
                padding: "4vh 0",
                margin: 0,
              }}
            >
              Damage summary
            </h2>

            <table
              style={{
                width: "100%",
                border: "1px solid #dadada",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
            >
              <tbody>
                {damageList.length > 0 ? (
                  damageList.map((dmg: any, idx: number) => {
                    if (!dmg?.aiag) return null;

                    const code =
                      dmg.aiag.damageArea?.code +
                      dmg.aiag.damageType?.code +
                      dmg.aiag.damageSeverity?.code;
                    
                    const label =
                      dmg.aiag.damageArea?.description + ', ' +
                      dmg.aiag.damageType?.description + ', ' +
                      dmg.aiag.damageSeverity?.description;

                    return (
                      <tr key={idx} style={{ border: "2px solid #dadada" }}>
                        <td style={codeStyle}>{code}</td>
                        <td style={descStyle}>
                          {label}
                        </td>
                        <td style={codeStyle}>{dmg?.source?.toUpperCase() || "-"}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={3}
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        fontSize: "1.5rem",
                      }}
                    >
                      No damage data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ---------------- FOOTER ---------------- */}
      <div
        className="pdf-footer"
        style={{
          background: "#f6f6f6",
          borderLeft: "20px solid #e94f2c",
        }}
      >
        <footer
          style={{
            borderTop: "1px solid #dadada",
            padding: "60px 80px",
            background: "#FFFFFF",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img
            src={logo}
            width={250}
            height={50}
            alt="Prism"
          />

          <div style={{ color: "#777", fontSize: "1.2rem" }}>
            <a href="https://www.sphereglobal.com/">
              A.I. Powered Damage Detection
            </a>{" "}
            | <a href="mailto:sales@sphereglobal.com">sales@sphereglobal.com</a>{" "}
            | <a href="tel:+173235786001">+1732-357-8600</a>
          </div>
        </footer>
      </div>

      <div
        className="pdf-first-footer"
        style={{
          background: "#f6f6f6",
          // borderLeft: "20px solid #e94f2c",
        }}
      >
        <footer
          style={{
            borderTop: "1px solid #dadada",
            padding: "60px 80px",
            background: "#FFFFFF",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img
            src={logo}
            width={250}
            height={50}
            alt="Prism"
          />

          <div style={{ color: "#777", fontSize: "1.2rem" }}>
            <a href="https://www.sphereglobal.com/">
              A.I. Powered Damage Detection
            </a>{" "}
            | <a href="mailto:sales@sphereglobal.com">sales@sphereglobal.com</a>{" "}
            | <a href="tel:+173235786001">+1732-357-8600</a>
          </div>
        </footer>
      </div>
    </>
  );
};

/* ---------------- styles ---------------- */
const cellStyle: React.CSSProperties = {
  width: "50%",
  border: "1px solid #dadada",
  padding: "3vh 5vw",
  fontSize: "1.5rem",
};

const valueStyle: React.CSSProperties = {
  color: "#777",
};

const codeStyle: React.CSSProperties = {
  width: "2%",
  padding: "3vh 3vw",
  // fontSize: "1.5rem",
};

const descStyle: React.CSSProperties = {
  width: "96%",
  padding: "3vh 0",
  // fontSize: "1.5rem",
};

export default DamagePdf;